var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurveLineUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.635,
    height: 16.295,
    viewBox: "0 0 23.635 16.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44084",
    "data-name": "Path 44084",
    d: "M319.686,180.367a.808.808,0,1,0,1.142,1.142Zm8.645-7.5.448-.672a.809.809,0,0,0-1.019.1Zm4.4,2.936-.448.672a.809.809,0,0,0,1.019-.1Zm10.349-9.542a.807.807,0,0,0-.807-.807h-7.267a.807.807,0,0,0,0,1.615h6.459v6.459a.807.807,0,1,0,1.615,0Zm-22.257,15.251,8.074-8.074-1.142-1.142-8.074,8.074Zm7.055-7.973,4.4,2.936.9-1.345-4.4-2.936Zm5.423,2.835,9.542-9.542-1.142-1.142-9.542,9.542Z",
    transform: "translate(-319.45 -165.45)",
    fill: "#4dab46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveLineUp);
export default __webpack_public_path__ + "static/media/curve-line-up.d7fc3fd87a2a7e2c8d680da3808f442a.svg";
export { ForwardRef as ReactComponent };